<template>
  <v-app
    id="app"
    :class="[$mq, { 'menu-opened': menuStatus, 'modal-opened': modalStatus }]"
  >
    <div class="wrapper">
      <bos-header v-if="!specialHeader" />
      <bex-header
        v-if="specialHeader"
        :fair-id="$route.params.code"
        service-group="VERS"
        :regi-nr="$route.params.booth"
        base-url=""
        container-width="78em"
        :language="currentLang"
      />

      <main>
        <router-view />
      </main>

      <bos-footer />
    </div>
  </v-app>
</template>

<script>
import BosHeader from '@/components/BosHeader'
import BosFooter from '@/components/BosFooter'

export default {
  data() {
    return {
      backUrlBase:
        process.env.VUE_APP_BASEURL || process.env.VUE_APP_BASEURL_DEFAULT
    }
  },
  computed: {
    currentLang() {
      return this.$store.getters['ui/getLocale'].substring(0, 2)
    },
    specialHeader() {
      return this.$store.getters['ui/specialHeader']
    },
    menuStatus() {
      return this.$store.getters['ui/menuStatus']
    },
    modalStatus() {
      return this.$store.getters['ui/modalStatus']
    }
  },
  created() {
    this.$root.$on('toggle::menustate', state => {
      this.$store.commit(
        'ui/setMenuStatus',
        state !== undefined ? state : !this.menuStatus
      )
    })

    this.$store.commit('ui/setMenuStatus', false)
    this.$store.commit('ui/setModalStatus', false)
  },
  methods: {
    userLoaded: function() {
    }
  },
  mounted() {
    window.addEventListener('vuexoidc:userLoaded', this.userLoaded)

    const locale = localStorage.getItem('locale')
    if (locale !== null) {
      this.$store.commit('ui/setLocale', locale)
    }
  },
  destroyed() {
    window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
  },
  components: {
    BosFooter,
    BosHeader
  }
}
</script>

<style lang="scss">
@import '~@blaze/css/dist/blaze.css';
@import '~vue-select/dist/vue-select.css';

@import './assets/css/variables.scss';
@import './assets/css/modules/tag-a.scss';
@import './assets/css/modules/tag-table.scss';
@import './assets/css/modules/text.scss';
@import './assets/css/modules/headings.scss';
@import './assets/css/modules/lists.scss';
@import './assets/css/modules/tooltip.scss';
@import './assets/css/modules/tabs.scss';
@import './assets/css/modules/print.scss';

@import url('https://fonts.googleapis.com/css?family=Ropa+Sans');

@font-face {
  font-family: 'DINPro';
  src: local('DINPro Light'), url('./assets/fonts/DINPro-Light.woff') format('woff');
  font-style: normal;
  font-weight: 300;
}

@font-face {
  font-family: 'DINPro';
  src: local('DINPro Bold'), url('./assets/fonts/DINPro-Bold.woff') format('woff');
  font-style: normal;
  font-weight: 700;
}

body {
  font-family: $base-font-family;
  font-size: $base-font-size;
  font-weight: $base-font-weight;
  font-style: $base-font-style;
  color: $base-color;
  line-height: $base-line-height;
  letter-spacing: $base-letter-spacing;

  .sr-only {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
  }

  a,
  button {
    cursor: pointer;

    &:focus {
      outline: 0 none;
    }
  }

  strong {
    font-weight: $font-weight-bold;
  }

  .c-button {
    display: inline-block;
    color: #4187ba;
    font-size: 21px;
    background-color: #fff;
    padding: 7.5px 11px;
    border-radius: 0;
    font-weight: bold;
    letter-spacing: 0.6px;
    transition: all 0.3s;
    min-width: 191px;

    &:hover {
      color: #fff;
      background-color: #4187ba;
    }
  }

  .o-container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .o-grid {
    > .o-grid__cell {
      padding-left: $grid-gutter;
      padding-right: $grid-gutter;

      &.o-grid__cell--no-gutter {
        padding-left: 0;
        padding-right: 0;
      }
    }

    &.o-grid--no-gutter {
      > .o-grid__cell {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  .o-bg-cover {
    background-size: cover;
    background-position: 50% 50%;
  }
}

#app {
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  height: 100vh;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;

  .wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    > header {
      z-index: 5;
    }

    > main {
      position: relative;
      margin-top: 50px;
      z-index: 1;
    }

    > footer {
      z-index: 3;
    }
  }

  &.modal-opened {
    height: 100vh;
    overflow: hidden;
    overflow-y: hidden;
    -webkit-overflow-scrolling: unset;

    .wrapper {
      > main {
        z-index: 6;
      }
    }
  }

  &.md,
  &.sm,
  &.xs {
    &.menu-opened {
      .wrapper {
        overflow: hidden;
        height: 100%;
      }
    }
  }
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-dismissible {
  padding-right: 4rem;

  .close {
    background-color: transparent;
    border: 0;
    /* -webkit-appearance: none; */
    -moz-appearance: none;
    appearance: none;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.75rem 1.25rem;
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.5;
  }
}

  #app {
    overflow: initial;
    overflow-y: initial;
  }
</style>
